import React from 'react'
import Header from './ui/Header'
import { useLocation } from 'react-router-dom'
import Appereance from './ui/Appereance'
import { Sprite } from '@/components/Sprite'
import { ThemeProvider } from '@/components/ThemeProvider'
import { isMultistepQuiz } from '@/helpers/isMultistepQuiz'

interface LayoutProps {
  children: React.ReactNode
  className?: string
}

const Layout = (props: LayoutProps) => {
  const location = useLocation()
  const { pathname } = location
  const isMultiStepQuiz = pathname.startsWith('/quiz') || isMultistepQuiz()
  const hideBurgerCondition =
    pathname.startsWith('/email') ||
    pathname.startsWith('/paywall') ||
    pathname.startsWith('/thank-you')
  const isDesktopPage =
    pathname.startsWith('/terms-of-use') ||
    pathname.startsWith('/us/terms-of-use') ||
    pathname.startsWith('/eu/terms-of-use') ||
    pathname.startsWith('/subscription-terms') ||
    pathname.startsWith('/privacy-policy') ||
    pathname.startsWith('/us/privacy-policy') ||
    pathname.startsWith('/eu/privacy-policy')
  const isResultPage = pathname.startsWith('/fail-payment')
  const isBrandPage = pathname.startsWith('/new/') || pathname.startsWith('/new')

  if (isResultPage) {
    return (
      <ThemeProvider>
        <Appereance>
          <main
            className={`${props.className ? props.className + ' ' : ''}w-full flex flex-col relative`}
          >
            {props.children}
          </main>
        </Appereance>
      </ThemeProvider>
    )
  }

  if (isMultiStepQuiz) {
    return (
      <ThemeProvider>
        <Appereance>
          <div
            className={`${props.className ? props.className + ' ' : ''}w-full flex flex-col relative`}
          >
            <main className={'max-w-content w-full mx-auto box-border overflow-x-visible'}>
              {props.children}
            </main>
          </div>
        </Appereance>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider>
      <Sprite />
      {isDesktopPage ? (
        <>
          <Header version={isBrandPage} hideBurger desktop />
          <main className="max-w-desktop w-full mx-auto box-border overflow-x-visible">
            {props.children}
          </main>
        </>
      ) : (
        <Appereance>
          {pathname && pathname !== '/scan-results' && (
            <Header version={isBrandPage} hideBurger={hideBurgerCondition} />
          )}
          <div
            className={`${props.className ? props.className + ' ' : ''}w-full flex flex-col relative`}
          >
            <main
              className={`${pathname.includes('/intro') && !pathname.includes('/new') ? 'intro-main' : ''} max-w-content ${!pathname.includes('/thank-you') ? 'px-4' : ''} w-full mx-auto box-border overflow-x-visible`}
            >
              {props.children}
            </main>
          </div>
        </Appereance>
      )}
    </ThemeProvider>
  )
}

export default Layout
